import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';

import Checkbox from 'src/common/components/Checkbox';
import styles from './Category.module.scss';

export type CategoryProps = {
  categoryId: string;
  name: string;
  checked: boolean;
  onChange: (id: string, checked: boolean) => void;
};

const Category: FC<CategoryProps> = ({
  categoryId,
  name,
  checked,
  onChange,
}) => {
  const [t] = useTranslation('boat-categories');

  return (
    <li className={styles.root}>
      <label className={styles.label}>
        <Checkbox
          checked={checked}
          onChange={(isChecked) => onChange(categoryId, isChecked)}
        />
        <span className={styles.text}>
          {t(name)}
        </span>
      </label>
    </li>
  );
};

export default Category;
